import { map } from 'rxjs/operators';

import {
  NO_LIMIT_DATA,
  InitialDataChecksumToken,
  ReportDashboardComponentKind,
  VisualizeOperatorInput,
} from '@core/reports-types';

export const applyAmountOfDataSetting = ({
  component,
  data,
  metric,
  meta,
}: VisualizeOperatorInput): VisualizeOperatorInput => {
  if (data.checksum === InitialDataChecksumToken) {
    return { component, data, metric, meta };
  }
  const limit = component.settings?.amountOfDataDisplayed ?? NO_LIMIT_DATA;

  if (limit === NO_LIMIT_DATA || component.kind === ReportDashboardComponentKind.Trend) {
    return { component, data, metric, meta };
  }

  const results = {
    ...data.results,
    rows: data.results.rows.slice(0, limit),
  };

  const checksumDiff = limit === NO_LIMIT_DATA ? '' : `&limit=${limit}`;

  return {
    component,
    data: {
      ...data,
      checksum: data.checksum + checksumDiff,
      results,
    },
    metric,
    meta,
  };
};

export const applyAmountOfDataSettingPipe = map(applyAmountOfDataSetting);
